// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_SERVICE_PRO = '/service-pro';
const ROOTS = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_ROOTS = {
  root: ROOTS,
  blog: {
    root: path(ROOTS, '/blog'),
    posts: path(ROOTS, '/blog/posts'),
    post: path(ROOTS, '/blog/posts/:title')
  },
  news: {
    root: path(ROOTS, '/news'),
    posts: path(ROOTS, '/news/posts'),
    post: path(ROOTS, '/news/posts/:title')
  },
  comingSoon: path(ROOTS, '/coming-soon')
};

export const PATH_PAGE = {
  home: '/',
  maintenance: '/maintenance',
  about: '/about-us',
  faqs: '/faqs',
  terms: '/terms',
  privacy: '/privacy',
  page404: '/404',
  page500: '/500'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/home'),
    address: path(ROOTS_DASHBOARD, '/address'),
    residence: path(ROOTS_DASHBOARD, '/residence'),
    move: path(ROOTS_DASHBOARD, '/move'),
    home: path(ROOTS_DASHBOARD, '/home'),
    homeItems: path(ROOTS_DASHBOARD, '/home-items'),
    appliances: path(ROOTS_DASHBOARD, '/appliances'),
    appliancesEdit: path(ROOTS_DASHBOARD, '/appliances/edit'),
    utilities: path(ROOTS_DASHBOARD, '/utilities'),
    utilitiesEdit: path(ROOTS_DASHBOARD, '/utilities/edit'),
    warranties: path(ROOTS_DASHBOARD, '/warranties'),
    exterior: path(ROOTS_DASHBOARD, '/exterior'),
    exteriorEdit: path(ROOTS_DASHBOARD, '/exterior/edit'),
    services: path(ROOTS_DASHBOARD, '/services'),
    servicesCreate: path(ROOTS_DASHBOARD, '/services/create'),
    servicesEdit: path(ROOTS_DASHBOARD, '/services/edit'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    walkthrough: path(ROOTS_DASHBOARD, '/walkthrough'),
    quickAdd: path(ROOTS_DASHBOARD, '/quick-add'),
    tasks: path(ROOTS_DASHBOARD, '/tasks'),
    budget: path(ROOTS_DASHBOARD, '/budget'),
    binder: path(ROOTS_DASHBOARD, '/binder'),
    homeHealthReport: path(ROOTS_DASHBOARD, '/home-health-report'),
    lawnLeisure: path(ROOTS_DASHBOARD, '/lawnLeisure'),
    lawnLeisureEdit: path(ROOTS_DASHBOARD, '/lawnLeisure/edit'),
    furniture: path(ROOTS_DASHBOARD, '/furniture'),
    furnitureEdit: path(ROOTS_DASHBOARD, '/furniture/edit'),
    interior: path(ROOTS_DASHBOARD, '/interior'),
    interiorEdit: path(ROOTS_DASHBOARD, '/interior/edit'),
    myServicePros: path(ROOTS_DASHBOARD, '/my-service-pros'),
    invoices: path(ROOTS_DASHBOARD, '/invoices'),
    contacts: path(ROOTS_DASHBOARD, '/contacts'),
    contactsCreate: path(ROOTS_DASHBOARD, '/contacts/create'),
    contactsEdit: path(ROOTS_DASHBOARD, '/contacts/edit'),
    warranty: path(ROOTS_DASHBOARD, '/warranty'),
    warrantyCreate: path(ROOTS_DASHBOARD, '/warranty/create'),
    warrantyEdit: path(ROOTS_DASHBOARD, '/warranty/edit')
  },
  admin: {
    root: path(ROOTS_DASHBOARD, '/admin'),
    role: path(ROOTS_DASHBOARD, '/admin/role'),
    roleEdit: path(ROOTS_DASHBOARD, '/admin/role/edit'),
    brands: path(ROOTS_DASHBOARD, '/admin/brands'),
    brandsCreate: path(ROOTS_DASHBOARD, '/admin/brands/create'),
    brandsEdit: path(ROOTS_DASHBOARD, '/admin/brands/edit'),
    applianceType: path(ROOTS_DASHBOARD, '/admin/appliance-type'),
    applianceTypeCreate: path(ROOTS_DASHBOARD, '/admin/appliance-type/create'),
    applianceTypeEdit: path(ROOTS_DASHBOARD, '/admin/appliance-type/edit'),
    industryType: path(ROOTS_DASHBOARD, '/admin/industry-type'),
    industryTypeCreate: path(ROOTS_DASHBOARD, '/admin/industry-type/create'),
    industryTypeEdit: path(ROOTS_DASHBOARD, '/admin/industry-type/edit'),
    items: path(ROOTS_DASHBOARD, '/admin/items'),
    careFulfillment: path(ROOTS_DASHBOARD, '/admin/care-fulfillment'),
    companyClaims: path(ROOTS_DASHBOARD, '/admin/company-claims'),
    proFunnel: path(ROOTS_DASHBOARD, '/admin/footprint-funnel'),
    itemsNew: path(ROOTS_DASHBOARD, '/admin/items/new'),
    exteriorType: path(ROOTS_DASHBOARD, '/admin/exterior-type'),
    exteriorTypeCreate: path(ROOTS_DASHBOARD, '/admin/exterior-type/create'),
    exteriorTypeEdit: path(ROOTS_DASHBOARD, '/admin/exterior-type/edit'),
    utilitiesType: path(ROOTS_DASHBOARD, '/admin/utilities-type'),
    utilitiesTypeCreate: path(ROOTS_DASHBOARD, '/admin/utilities-type/create'),
    utilitiesTypeEdit: path(ROOTS_DASHBOARD, '/admin/utilities-type/edit'),
    homeHacks: path(ROOTS_DASHBOARD, '/admin/home-hacks'),
    homeHacksCreate: path(ROOTS_DASHBOARD, '/admin/home-hacks/create'),
    homeHacksEdit: path(ROOTS_DASHBOARD, '/admin/home-hacks/edit'),
    lawnLeisureType: path(ROOTS_DASHBOARD, '/admin/lawnLeisure-type'),
    lawnLeisureTypeCreate: path(ROOTS_DASHBOARD, '/admin/lawnLeisure-type/create'),
    lawnLeisureTypeEdit: path(ROOTS_DASHBOARD, '/admin/lawnLeisure-type/edit'),
    furnitureType: path(ROOTS_DASHBOARD, '/admin/furniture-type'),
    furnitureTypeCreate: path(ROOTS_DASHBOARD, '/admin/furniture-type/create'),
    furnitureTypeEdit: path(ROOTS_DASHBOARD, '/admin/furniture-type/edit'),
    interiorType: path(ROOTS_DASHBOARD, '/admin/interior-type'),
    interiorTypeCreate: path(ROOTS_DASHBOARD, '/admin/interior-type/create'),
    interiorTypeEdit: path(ROOTS_DASHBOARD, '/admin/interior-type/edit'),
    emailNotication: path(ROOTS_DASHBOARD, '/admin/email-notification'),
    // Admin broadcasts behind the dashboard alert bar (card 158).
    broadcasts: path(ROOTS_DASHBOARD, '/admin/broadcasts'),
    blog: path(ROOTS_DASHBOARD, '/admin/blog'),
    blogCreate: path(ROOTS_DASHBOARD, '/admin/blog/create'),
    blogEdit: path(ROOTS_DASHBOARD, '/admin/blog/edit'),
    news: path(ROOTS_DASHBOARD, '/admin/news'),
    newsCreate: path(ROOTS_DASHBOARD, '/admin/news/create'),
    newsEdit: path(ROOTS_DASHBOARD, '/admin/news/edit'),
    comingSoon: path(ROOTS_DASHBOARD, '/admin/coming-soon'),
    comingSoonCreate: path(ROOTS_DASHBOARD, '/admin/coming-soon/create'),
    comingSoonEdit: path(ROOTS_DASHBOARD, '/admin/coming-soon/edit')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, '/user/ada-lindgren/edit'),
    account: path(ROOTS_DASHBOARD, '/user/account')
  }
};

export const PATH_SERVICE_PRO = {
  dashboard: path(ROOTS_SERVICE_PRO, '/dashboard'),
  addressSearch: path(ROOTS_SERVICE_PRO, '/address-search'),
  customers: path(ROOTS_SERVICE_PRO, '/customers'),
  customersCreate: path(ROOTS_SERVICE_PRO, '/customers/create'),
  customersEdit: path(ROOTS_SERVICE_PRO, '/customers/edit'),
  customersMap: path(ROOTS_SERVICE_PRO, '/customers/map'),
  inspections: path(ROOTS_SERVICE_PRO, '/inspections'),
  suggestedOutreach: path(ROOTS_SERVICE_PRO, '/suggested-outreach'),
  dispatch: path(ROOTS_SERVICE_PRO, '/dispatch'),
  plans: path(ROOTS_SERVICE_PRO, '/plans'),
  territories: path(ROOTS_SERVICE_PRO, '/territories'),
  trial: path(ROOTS_SERVICE_PRO, '/trial'),
  invoices: path(ROOTS_SERVICE_PRO, '/invoices'),
  crm: path(ROOTS_SERVICE_PRO, '/crm'),
  marketing: path(ROOTS_SERVICE_PRO, '/marketing'),
  campaigns: path(ROOTS_SERVICE_PRO, '/campaigns'),
  pro: {
    company: path(ROOTS_SERVICE_PRO, '/pro/company'),
    companyCreate: path(ROOTS_SERVICE_PRO, '/pro/company/create'),
    companyEdit: path(ROOTS_SERVICE_PRO, '/pro/company/edit'),
    users: path(ROOTS_SERVICE_PRO, '/pro/users'),
    usersCreate: path(ROOTS_SERVICE_PRO, '/pro/users/create'),
    usersEdit: path(ROOTS_SERVICE_PRO, '/pro/users/edit')
  },
  admin: {
    addCompany: path(ROOTS_SERVICE_PRO, '/admin/company/add'),
    listCompany: path(ROOTS_SERVICE_PRO, '/admin/company'),
    editCompany: path(ROOTS_SERVICE_PRO, '/admin/company/edit'),
    companyType: path(ROOTS_SERVICE_PRO, '/admin/company-type'),
    companyTypeCreate: path(ROOTS_SERVICE_PRO, '/admin/company-type/create'),
    companyTypeEdit: path(ROOTS_SERVICE_PRO, '/admin/company-type/edit')
  }
};
